import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="border-b border-ink/10 bg-cream" data-id="element-71" data-mp="oiawn8ptjceh">
      <div className="mx-auto grid max-w-page gap-12 px-6 pb-16 pt-14 lg:grid-cols-12 lg:items-end lg:gap-10 lg:px-10 lg:pb-20 lg:pt-24" data-id="element-72" data-mp="jnx7vp5nw3is">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-span-5" data-id="element-73" data-mp="eoaunfpu2n9z">
          <h1 className="font-serif text-[2.6rem] font-light leading-[1.05] tracking-tight text-ink sm:text-6xl lg:text-[4.1rem]" data-id="element-74" data-mp="q45cnyy9vlx">
            Rendre le corps
            <span className="block italic text-sage-deep" data-id="element-75" data-mp="3ryi0bf88h9n9">à nouveau disponible.</span>
          </h1>
          <p className="mt-7 max-w-md text-[1.0625rem] leading-relaxed text-ink/70" data-id="element-76" data-mp="1v3lvmiqqp6kn">
            Pilates, Stretching Postural® et Munz Floor® à Angers et en ligne. Des séances lentes et précises,
            pensées pour votre corps tel qu’il est aujourd’hui — pas pour une performance.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-77" data-mp="1rwqna3e17b31">
            <Link to="/contact" className="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm text-ivory transition-colors duration-150 ease-soft hover:bg-sage-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-78" data-mp="1cz7xcxpmaru0">
              Réserver un cours d’essai
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="1vvzfh3tfb0wh" />
            </Link>
            <Link to="/les-cours" className="text-sm text-ink underline decoration-ink/25 decoration-1 underline-offset-[6px] transition-colors duration-150 ease-soft hover:decoration-ink" data-id="element-80" data-mp="20vc15l8k61xh">
              Découvrir les trois méthodes
            </Link>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-span-7" data-id="element-81" data-mp="337v9ltk0djiu">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/b0de36d3-e9d0-4ebd-94d3-a6ee8cc3819a.jpg" alt="Christine Velluet en extension du buste sur un tapis, dans un studio lumineux" className="aspect-[3/2] w-full object-cover" data-id="element-82" data-mp="2p8m3xntfi7t4" />
          <dl className="mt-6 grid grid-cols-3 divide-x divide-ink/10 border-t border-ink/10 pt-6 text-sm" data-id="element-83" data-mp="2ajpnp3h7xohf">
            <div className="pr-4" data-id="element-84" data-mp="26ie71ngbodld">
              <dt className="text-ink/50" data-id="element-85" data-mp="26j5qy10k4mvt">Expérience</dt>
              <dd className="mt-1 font-serif text-xl text-ink" data-id="element-86" data-mp="21j1jf0hmn2hq">20 ans</dd>
            </div>
            <div className="px-4" data-id="element-87" data-mp="21kvuzo70di95">
              <dt className="text-ink/50" data-id="element-88" data-mp="1wjoortkikr4l">Groupes</dt>
              <dd className="mt-1 font-serif text-xl text-ink" data-id="element-89" data-mp="1wm1c6m91jtp1">8 max.</dd>
            </div>
            <div className="pl-4" data-id="element-90" data-mp="c40bzxa6bajj">
              <dt className="text-ink/50" data-id="element-91" data-mp="h0qtmp1mme72">Formats</dt>
              <dd className="mt-1 font-serif text-xl text-ink" data-id="element-92" data-mp="gz5wqsruaj61">Salle & ligne</dd>
            </div>
          </dl>
        </motion.div>
      </div>
    </section>;
}